var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSave2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0.5 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33268 1.83398H12.666C13.0342 1.83398 13.3327 2.13246 13.3327 2.50065V15.2629C13.3327 15.4469 13.1834 15.5963 12.9993 15.5963C12.9367 15.5963 12.8753 15.5785 12.8223 15.5453L7.99935 12.5215L3.17641 15.5453C3.02044 15.6431 2.81472 15.5959 2.71693 15.4399C2.68366 15.3869 2.66602 15.3255 2.66602 15.2629V2.50065C2.66602 2.13246 2.9645 1.83398 3.33268 1.83398ZM11.9993 3.16732H3.99935V13.4556L7.99935 10.9478L11.9993 13.4556V3.16732Z",
    fill: "#12C0B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSave2);
export default __webpack_public_path__ + "static/media/icon-save2.551bdd45ca670fc0fa18f3ba0376b1f5.svg";
export { ForwardRef as ReactComponent };